<form class="www-tra-fil www-form www-act-acc__con__form" [formGroup]="filterFormGroup">
  @if (sortTable().length) {
    <div class="www-tra-fil__sec">
      <h3 class="www-tra-fil__sec__tit">Sortowanie</h3>

      <div class="www-tra-fil__sec__box">
        <!-- <div class="group">
          <a (click)="sortDirectionChange()">
            {{ f['direction'].value === null ? 'Kierunek sortowania' : 'Sortowanie' }}
            {{ f['direction'].value === null ? '' : f['direction'].value === 'asc' ? ' a...Z' : ' Z...a' }}
          </a>
        </div> -->
        <div class="group group--select">
          <ng-select
            [closeOnSelect]="true"
            [dropdownPosition]="'bottom'"
            [formControlName]="'sort'"
            [multiple]="false"
            [virtualScroll]="false"
            id="sort"
            placholder="Sortuj po"
            [ngClass]="{ used: f['sort'].value, 'mt-5': f['sort'].value }"
          >
            @for (e of sortTable(); track $index) {
              <ng-option [value]="e.value">{{ e.name }}</ng-option>
            }
          </ng-select>
          <label [for]="'sort'">Sortuj po</label>
        </div>

        @if (f.sort.value !== null) {
          <div class="group group--select">
            <ng-select
              [closeOnSelect]="true"
              [dropdownPosition]="'bottom'"
              [formControlName]="'direction'"
              [multiple]="false"
              [virtualScroll]="false"
              id="direction"
              placholder="Kierunek sortowania"
              class="mt-4"
              [ngClass]="{ used: f['direction'].value }"
            >
              <ng-option [value]="'asc'">Rosnąco</ng-option>
              <ng-option [value]="'desc'">Malejąco</ng-option>
            </ng-select>
            <label [for]="'sort'">Kierunek sortowania</label>
          </div>
        }
      </div>
    </div>
  }

  @if (places()) {
    <div class="www-tra-fil__sec">
      <h3 class="www-tra-fil__sec__tit">Akademie</h3>

      <div class="www-tra-fil__sec__box">
        <div class="group">
          <label class="radio radio--rect">
            <input name="place_id" [formControlName]="'place_id'" [value]="null" type="radio" />
            <span class="design"></span>
            <span class="text">Dowolna</span>
          </label>
        </div>

        @for (p of places(); track $index) {
          <div class="group">
            <label class="radio radio--rect">
              <input name="place_id" [formControlName]="'place_id'" [value]="p.id" type="radio" />
              <span class="design"></span>
              <span class="text">{{ p.name }}</span>
            </label>
          </div>
        }
      </div>
    </div>
  }

  @if (cities()) {
    <div class="www-tra-fil__sec">
      <h3 class="www-tra-fil__sec__tit">Lokalizacja</h3>

      <div class="www-tra-fil__sec__box">
        <div class="group">
          <label class="radio radio--rect">
            <input name="city" [formControlName]="'city'" [value]="null" type="radio" />
            <span class="design"></span>
            <span class="text">Dowolna</span>
          </label>
        </div>

        @for (p of cities(); track $index) {
          <div class="group">
            <label class="radio radio--rect">
              <input name="city" [formControlName]="'city'" [value]="p" type="radio" />
              <span class="design"></span>
              <span class="text">{{ p }}</span>
            </label>
          </div>
        }
      </div>
    </div>
  }

  <div class="www-tra-fil__sec">
    <h3 class="www-tra-fil__sec__tit">Format</h3>

    <div class="www-tra-fil__sec__box">
      <div class="group">
        <label class="radio radio--rect">
          <input name="format" [formControlName]="'format'" [value]="null" type="radio" />
          <span class="design"></span>
          <span class="text">Dowolny</span>
        </label>
      </div>

      <div class="group">
        <label class="radio radio--rect">
          <input name="format" [formControlName]="'format'" [value]="'offline'" type="radio" />
          <span class="design"></span>
          <span class="text">Stacjonarne</span>
        </label>
      </div>

      <div class="group">
        <label class="radio radio--rect">
          <input name="format" [formControlName]="'format'" [value]="'online'" type="radio" />
          <span class="design"></span>
          <span class="text">Online</span>
        </label>
      </div>
    </div>
  </div>

  @if (isBrandFilterVisible()) {
    <div class="www-tra-fil__sec">
      <h3 class="www-tra-fil__sec__tit">Marka</h3>

      <div class="www-tra-fil__sec__box">
        <div class="group">
          <label class="radio radio--rect">
            <input name="brand" [formControlName]="'brand'" [value]="null" type="radio" />
            <span class="design"></span>
            <span class="text">Dowolna</span>
          </label>
        </div>

        <div class="group">
          <label class="radio radio--rect">
            <input name="brand" [formControlName]="'brand'" [value]="TrainingBrand.LOREAL_PROFESSIONNEL" type="radio" />
            <span class="design"></span>
            <span class="text">L’Oreal Professionnel</span>
          </label>
        </div>

        <div class="group">
          <label class="radio radio--rect">
            <input name="brand" [formControlName]="'brand'" [value]="TrainingBrand.KERASTASE" type="radio" />
            <span class="design"></span>
            <span class="text">Kerastase</span>
          </label>
        </div>

        <div class="group">
          <label class="radio radio--rect">
            <input name="brand" [formControlName]="'brand'" [value]="TrainingBrand.REDKEN" type="radio" />
            <span class="design"></span>
            <span class="text">Redken</span>
          </label>
        </div>
      </div>
    </div>
  }

  @if (maxRangeValue() !== null) {
    <div class="www-tra-fil__sec">
      <h3 class="www-tra-fil__sec__tit">Cena</h3>

      <div class="www-tra-fil__sec__box">
        <div class="d-flex justify-content-start align-items-center">
          <div class="group mt-0 mb-0">
            <input class="price" [formControlName]="'price_from_txt'" type="number" />
          </div>

          &nbsp;-&nbsp;
          <div class="group mt-0 mb-0">
            <input class="price" [formControlName]="'price_to_txt'" type="text" type="number" />
          </div>
        </div>
        <div class="group range-min-max">
          <div class="sliders_control">
            <input
              id="fromSlider"
              type="range"
              [value]="0"
              [formControlName]="'price_from'"
              [max]="maxRangeValue()"
              (change)="priceFromChange()"
            />
            <input
              id="toSlider"
              type="range"
              [value]="0"
              [formControlName]="'price_to'"
              [max]="maxRangeValue()"
              (change)="priceToChange()"
            />
          </div>
        </div>

        <div class="group mt-0">
          <label class="radio radio--rect">
            <input name="payment" [formControlName]="'payment'" [value]="'free'" type="checkbox" />
            <span class="design"></span>
            <span class="text">Bezpłatne szkolenia</span>
          </label>
        </div>
      </div>
    </div>
  }

  @if (educators()) {
    <div class="www-tra-fil__sec">
      <h3 class="www-tra-fil__sec__tit">Prowadzący</h3>

      <div class="group">
        <div class="group group--select">
          <ng-select
            [closeOnSelect]="true"
            [dropdownPosition]="'bottom'"
            [formControlName]="'educator_id'"
            [multiple]="false"
            [virtualScroll]="false"
            id="educator_id"
            placholder="Wybierz edukatora"
            [ngClass]="{ used: f['educator_id'].value }"
          >
            @for (e of educators(); track $index) {
              <ng-option [value]="e.id">{{ e.firstname + ' ' + e.lastname }}</ng-option>
            }
          </ng-select>
          <label [for]="'educator_id'">Wybierz edukatora</label>
        </div>
      </div>
    </div>
  }

  <div class="www-tra-fil__sec">
    <h3 class="www-tra-fil__sec__tit">Termin</h3>

    <div class="www-tra-fil__sec__box">
      <div class="group dp">
        <input
          type="text"
          [minDate]="minDate"
          #dp="bsDatepicker"
          bsDatepicker
          [bsConfig]="{ containerClass: 'filter-dp', showWeekNumbers: false }"
          [formControlName]="'date_from'"
          [ngClass]="{ value: f['date_from'].value }"
        />
        <label for="dateFrom">Data od:</label>
      </div>
    </div>

    <div class="www-tra-fil__sec__box">
      <div class="group dp">
        <input
          type="text"
          #dp2="bsDatepicker"
          [minDate]="minDateMax()"
          bsDatepicker
          [bsConfig]="{ containerClass: 'filter-dp', showWeekNumbers: false }"
          [formControlName]="'date_to'"
          [ngClass]="{ value: f['date_to'].value }"
        />
        <label for="dateFrom">Data do:</label>
      </div>
    </div>
  </div>

  @if (isCategoriesFilterVisible()) {
    <div class="www-tra-fil__sec">
      <h3 class="www-tra-fil__sec__tit">Kategoria</h3>
      <div class="www-tra-fil__sec__box">
        <div class="group">
          <label class="radio radio--rect">
            <input name="category_id" [formControlName]="'category_id'" [value]="null" type="radio" />
            <span class="design"></span>
            <span class="text">Dowolna</span>
          </label>
        </div>
        @for (c of categoriesByBrand(); track $index) {
          <div class="group">
            <label class="radio radio--rect">
              <input name="category_id" [formControlName]="'category_id'" [value]="c.categoryId" type="radio" />
              <span class="design"></span>
              <span class="text">{{ c.categoryName }}</span>
            </label>
          </div>
          @if (c?.subCategories?.length && c.categoryId === f['category_id'].value) {
            <div class="ps-2">
              @for (sc of c.subCategories; track $index) {
                <div class="group">
                  <label class="radio radio--rect">
                    <input name="sub_category_id" [formControlName]="'sub_category_id'" [value]="sc.id" type="radio" />
                    <span class="design"></span>
                    <span class="text">{{ sc.name }}</span>
                  </label>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  }

  <!-- @if (educators()) {
    <div class="www-tra-fil__sec">
      <h3 class="www-tra-fil__sec__tit">Prowadzący</h3>

      <div class="group">
        <select class="form-select" aria-label="Wybierz prowadzącego" [formControlName]="'educator_id'">
          <option selected [value]="null">Dowolny</option>
          @for (e of educators(); track $index) {
            <option [value]="e.id">{{ e.firstname + ' ' + e.lastname }}</option>
          }
        </select>
      </div>
    </div>
  } -->
</form>
